<template>
  <v-container grid-list-md>
    <v-card class="elevation-0 transparent" height="70px">
      <v-card-title 
        primary-title 
        class="layout justify-center"
      >
        <div class="h_second_line">
          {{ $t('h_about_head_03') }}
        </div>
      </v-card-title>
    </v-card>
    <v-divider></v-divider>
    <div 
      v-for="(item, i) in progressMap"
      :key="i"
    >
     <v-progress-linear
        :color="item.color"
        height="25"
        :value=getCountPercent(item.yearsFrom)
        striped
        rounded
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <strong class="abtext" v-on="on">{{ item.name }} {{ getCountPercent(item.yearsFrom) }}% </strong>
          </template>
          <span>Experience over {{ getCountYears(item.yearsFrom) }} year(s) from {{ getCountExperience() }} year(s)</span>
        </v-tooltip>
      </v-progress-linear>
      <br>
    </div>
  </v-container> 
</template>

<script>
  import my_general_json from '@/assets/static/general.json'
  export default {
  data(){
      return{
        t_general: my_general_json
      }
    },
    computed:{
      progressMap(){
        return this.$store.getters.getPM
      }
    },
    methods:{
      getCountPercent(level){
        let progressDate = new Date().getFullYear();
        let startDate = this.t_general.workStartYear;
        let countYears = progressDate - level;
        let generalYears = progressDate - startDate;
        let result = (countYears / generalYears) * 100;
        return Math.floor(result);
      },
      getCountYears(level){
        let progressDate = new Date().getFullYear();
        let countYears = progressDate - level;
        return countYears;
      },
      getCountExperience(){
        let progressDate = new Date().getFullYear();
        let startDate = this.t_general.workStartYear;
        let result = progressDate - startDate;
        return result;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>